import {FormattedMessage} from "react-intl"
import React from "react"
import moment from "moment"

export default {
	load() {
		return {
			fields: {
				identifier: {
					//definujeme len staticke props ako su label, placeholder, ktore sa nemenia za behu...
					label: <FormattedMessage id="Patient.form.patientinfo.identifier" />,
					// rules: "required|string|between:9,10",
					rules: "required"
				},
				// Hodnota rodneho cisla pred zmenou od usera
				identifierOld: {},
				dateOfBirth: {
					label: <FormattedMessage id="Common.label.dateOfBirth" />,
					rules: "required",
					type: "date"
				},
				gender: {
					label: <FormattedMessage id="Common.label.gender" />,
					rules: "required|string"
				},
				insurer: {
					label: <FormattedMessage id="Common.label.insurer" />,
					rules: "required|string"
				},
				insurerCode: {}, // for check insurance call -> hidden field
				title_before: {
					label: <FormattedMessage id="Common.label.titleBefore" />,
					rules: "string"
				},
				firstname: {
					label: <FormattedMessage id="Common.label.firstName" />,
					rules: "required|string"
				},
				lastname: {
					label: <FormattedMessage id="Common.label.lastName" />,
					rules: "required|string"
				},
				birth_name: {
					label: <FormattedMessage id="Common.label.birthName" />
				},
				title_after: {
					label: <FormattedMessage id="Common.label.titleAfter" />,
					rules: "string"
				},
				street: {
					label: <FormattedMessage id="Common.label.street" />,
					rules: "string"
				},
				houseNumber: {
					label: <FormattedMessage id="Common.label.number" />,
					rules: "string"
				},
				city: {
					label: (
						<span>
							<FormattedMessage id="Common.label.city" />
						</span>
					)
					// rules: "string",
				},
				cityText: {},
				zip: {
					label: (
						<span>
							<FormattedMessage id="Common.label.zip" />
						</span>
					)
					// rules: "string",
				},
				zipText: {},
				country: {
					label: <FormattedMessage id="Patient.form.patientinfo.country" />,
					rules: "required",
					value: "SK"
				},
				region: {
					label: <FormattedMessage id="Common.label.region" />
					// rules: "required|string",
				},
				county: {
					label: <FormattedMessage id="Common.label.county" />
					// rules: "required|string",
					// value: "SK"
				},
				from: {
					value: moment()
						.startOf("year")
						.format("YYYY-MM-DD")
				},
				deathDate: {
					label: <FormattedMessage id="PrintTemplate.DeadReport.datumUmrtia" />,
					type: "date"
				},
				mobile: {
					label: <FormattedMessage id="Patient.form.contactForm.mobile" defaultMessage="Mobile" />,
					placeholder: "+421999000000",
					value: "+421"
					// rules: "required|string"
				},
				email: {
					label: <FormattedMessage id="Common.label.email" defaultMessage="Email" />,
					rules: "string"
				},
				phone: {
					label: <FormattedMessage id="Patient.form.contactForm.phone" defaultMessage="Phone" />,
					placeholder: "+421999000000",
					rules: "string"
				},
				description: {
					label: <FormattedMessage id="Common.label.description" defaultMessage="Description" />,
					rules: "string"
				}
			}
		}
	}
}
